module.exports = __webpack_public_path__ + "static/media/forgotpass.395991e2.jpg";